const hasExpired = (expirationTimeStamp) => {
    if (!expirationTimeStamp) {
        return true;
    }

    let expirationDate = new Date(expirationTimeStamp);

    // expirationTimeStamp might actually be a number that needs to be parsed
    if (isNaN(expirationDate.getTime())) {
        expirationDate = new Date(parseInt(expirationTimeStamp));
    }

    // Date is still invalid
    if (isNaN(expirationDate.getTime())) {
        return true;
    } else if (Date.now() > expirationDate) {
        return true;
    } else {
        return false;
    }
};

export default hasExpired;
